import qs from 'qs';
import jsBridge from './jsBridge';

const IOS_SIGN = 1; //iOS标志
const ANDROID_SIGN = 2; //iOS标志
const DEFAULT = '1'; //默认参数值
const PAY_STATUS = ['WX_MOBILE', 'ALI_MOBILE', 'QQ_MOBILE'];
export function formatDateTime(timeStamp: any) {
  if (!timeStamp) return '';

  let date = new Date(timeStamp);
  let y = date.getFullYear();
  let m: any = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  let d: any = date.getDate();
  d = d < 10 ? '0' + d : d;
  let h: any = date.getHours();
  h = h < 10 ? '0' + h : h;
  let minute: any = date.getMinutes();
  let second: any = date.getSeconds();
  minute = minute < 10 ? '0' + minute : minute;
  second = second < 10 ? '0' + second : second;
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
}

export function formatDate(timeStamp: any, type = 1) {
  //type  1 年月日   2 用点分隔
  let date = new Date(timeStamp);
  let y = date.getFullYear();
  let m: any = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  let d: any = date.getDate();
  d = d < 10 ? '0' + d : d;
  if (type === 1) {
    return y + '年' + m + '月' + d + '日';
  } else if (type === 2) {
    return y + '.' + m + '.' + d;
  }
}
// 日期格式化,t：传入的时间戳，o：true(没有年)，false(有年) i:true(有时间),false(没时间)
export function getTime(t: any, o: any, i: any) {
  let time = new Date(t);
  let year = time.getFullYear() + '年';
  let month = time.getMonth() + 1 + '月';
  let date = time.getDate() + '日';
  let hours = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
  let min = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
  if (!o) {
    if (i) {
      return year + month + date + ' ' + hours + ':' + min;
    } else {
      return year + month + date;
    }
  } else {
    if (i) {
      return month + date + ' ' + hours + ':' + min;
    } else {
      return month + date;
    }
  }
}
export function get_Time(t: any, o: any, i: any) {
  let time = new Date(t);
  let year = time.getFullYear() + '-';
  let month = time.getMonth() + 1 + '-';
  let date = time.getDate();
  let hours = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
  let min = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
  if (!o) {
    if (i) {
      return year + month + date + ' ' + hours + ':' + min;
    } else {
      return year + month + date;
    }
  } else {
    if (i) {
      return month + date + ' ' + hours + ':' + min;
    } else {
      return month + date;
    }
  }
}
/*查询参数*/
export function getQueryString(name: string) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

export function _IsAS() {
  var ua = navigator.userAgent.toLowerCase();
  if (/(iPhone|iPad|iPod|iOS|Mac)/i.test(navigator.userAgent)) {
    return 1;
  } else if (ua.match(/Android/i)) {
    return 2;
  } else if (ua.match(/Harmony/i)) {
    return 3;
  }
}

// 获取cookie字符串
export function getCookie(name: string) {
  let strcookie: any = document.cookie;
  let r = new RegExp(name + '=([^,;]*)');

  if (strcookie.match(r)) {
    return strcookie.match(r)[1];
  }
  return '';
}

export const $cookie = {
  
  getCookie: function (t:any) {
    return null ==
      document.cookie.match(RegExp("(^" + t + "| " + t + ")=([^;]*)"))
      ? ""
      : decodeURIComponent(RegExp.$2);
  },
  // setCookie: function (t:any, e:any, i:any) {
  //   (i = new Date(new Date().getTime() + 36e5 * i)),
  //     (document.cookie =
  //       t + "=" + escape(e) + "; path=/; expires=" + i.toGMTString());
  // },
  // delCookie: function (t:any) {
  //   $cookie.setCookie(t, "", -1);
  // },
  getVersionCookie: function (name:any) {
    var strcookie:any = $cookie.getCookie("zwzt_version")
      ? $cookie.getCookie("zwzt_version")
      : ""; //获取cookie字符串
    var r = new RegExp(name + "=([^,]*)");

    if (strcookie.match(r)) {
      return strcookie.match(r)[1];
    }
    return "";
  },
};
//外链跳回app
export function openappfunc(url: string) {
  let schemeUrl = 'zuowenzhitiao://com.qihe';
  let webviewUrl = `${schemeUrl}?routerUrl=${encodeURIComponent(`zuowenzhitiao://main/webView?url=${encodeURIComponent(url)}`)}`;
  openApp(webviewUrl);
}
export function navigortApp(url: string) {
  let schemeUrl = 'zuowenzhitiao://com.qihe';
  let webviewUrl = `${schemeUrl}?routerUrl=${encodeURIComponent(url)}`;
  openApp(webviewUrl);
}
export function isEquipment() {
  let UA = navigator.userAgent,
    isAndroid = /android|adr|linux/gi.test(UA),
    isIOS = /iphone|ipod|ipad/gi.test(UA) && !isAndroid,
    isBlackBerry = /BlackBerry/i.test(UA),
    isWindowPhone = /IEMobile/i.test(UA),
    isMobile = isAndroid || isIOS || isBlackBerry || isWindowPhone;
  return {
    isAndroid: isAndroid,
    isIOS: isIOS,
    isMobile: isMobile,
    isWeixin: /MicroMessenger/gi.test(UA),
    isQQ: /QQ/gi.test(UA),
    isPC: !isMobile,
    isWeibo: /WeiBo/gi.test(UA)
  };
}

export function openApp(localUrl: string) {
  var downUrl = '';
  let _document: any = document;
  if (_IsAS() === 1) {
    if (isEquipment().isWeibo || isEquipment().isWeixin || isEquipment().isQQ) {
      _document.querySelector('.middle_page').classList.add('show');
      _document.querySelector('.middle_page').classList.add('show');
      _document.querySelector('.open_ua_img').classList.add('show');
    } else {
      downUrl = 'https://apps.apple.com/cn/app/id1207254643';
      //判断是否是ios,具体的判断函数自行百度
      window.location.href = localUrl;
      setTimeout(function () {
        window.location.href = downUrl;
      }, 2000);
    }
  } else if (_IsAS() === 2) {
    if (isEquipment().isWeixin) {
      downUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441280218858';
    } else if (isEquipment().isQQ) {
      downUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441283115905';
    } else {
      downUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441367392706';
    }
    if (isEquipment().isWeibo || isEquipment().isWeixin) {
      _document.querySelector('.middle_page').classList.add('show');
    } else if (isEquipment().isQQ) {
      window.location.href = localUrl;
      // setTimeout(function () {
      //   window.location.href = downUrl;
      // }, 2000);
    } else {
      // // uc无法自动唤起
      window.location.href = localUrl;
      // setTimeout(function () {
      //   window.location.href = downUrl;
      // }, 2000);
    }
    // _document.querySelector('.naviBox').classList.remove('hide');
  } else {
    window.location.href = 'http://www.zuowenzhitiao.com/';
  }
}
export function navigatorToApp(type: any, id: any) {
  let schemeUrl = 'zuowenzhitiao://com.qihe';
  let webviewHref = {
    long: 'zuowenzhitiao://note/longArticleDetail?noteId=',
    short: 'zuowenzhitiao://note/shortNoteDetail?noteId=',
    audio: 'zuowenzhitiao://note/audioArticleDetail?noteId=',
    section: 'zuowenzhitiao://note/paragraphDetail?paragraphId=',
    main: 'zuowenzhitiao://main/mainPage'
  };
  openApp(`${schemeUrl}?routerUrl=${encodeURIComponent(`${webviewHref[type]}${id}`)}`);
}
export function downloadApp() {
  // 先判断微信在判断qq
  if (_IsAS() === 1) {
    window.location.href = 'https://apps.apple.com/cn/app/id1207254643';
  } else if (_IsAS() === 2) {
    if (isEquipment().isWeixin) {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441280218858';
    } else if (isEquipment().isQQ) {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441283115905';
    } else {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441367392706';
    }
  } else {
    window.location.href = 'https://www.zuowenzhitiao.com/';
  }
}

//格式化倒数时间
//nowTime:现在时间戳，endTime：停止时间戳
export function formatCountDown(nowTime: any, endTime: any) {
  if (nowTime >= endTime) return { hours: '00', minute: '00', second: '00' };
  let diffSeconds: any = parseInt(((endTime - nowTime) / 1000).toString());
  let second: any = parseInt((diffSeconds % 60).toString());
  let minute: any = parseInt((diffSeconds / 60).toString()) % 60;
  let hours: any = parseInt((diffSeconds / 3600).toString());
  second = second < 10 ? '0' + second : second;
  minute = minute < 10 ? '0' + minute : minute;
  hours = hours < 10 ? '0' + hours : hours;
  return { hours, minute, second };
}
//设置夜间模式
export function setDayorNight() {
  let _document: any = document;
  if (getCookie('zwzt_night') === '1') {
    _document.querySelector('html').style.background = '#2B2A34';
    if (document.getElementsByTagName('body')[0].className.indexOf('zwzt_night') === -1) {
      document.getElementsByTagName('body')[0].classList.remove('zwzt_day');
      document.getElementsByTagName('body')[0].classList.add('zwzt_night');
    }
  } else {
    _document.querySelector('html').style.background = '#FFFFFF';
    if (document.getElementsByTagName('body')[0].className.indexOf('zwzt_day') === -1) {
      document.getElementsByTagName('body')[0].classList.remove('zwzt_night');
      document.getElementsByTagName('body')[0].classList.add('zwzt_day');
    }
  }
}

//调起支付
//参数：order: 订单，type: 支付类型
export function callPay(order: any, channelId: any) {
  let type = PAY_STATUS[channelId - 1];
  if (_IsAS() === IOS_SIGN) {
    window &&
      (window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.callPay &&
      (window as any).webkit.messageHandlers.callPay.postMessage(JSON.stringify({ order, type }));
  } else if (_IsAS() === ANDROID_SIGN) {
    window && (window as any).android && (window as any).android.callPay(order, type);
  }
}
export function callLogin(sign = DEFAULT) {
  if (_IsAS() === IOS_SIGN) {
    window &&
      (window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.LoginModel &&
      (window as any).webkit.messageHandlers.LoginModel.postMessage(sign);
  } else if (_IsAS() === ANDROID_SIGN) {
    window && (window as any).android && (window as any).android.callLogin(sign);
  }
}

export var EventUtil = {
  addHandler: function (element: any, type: any, handler: any) {
    if (element.addEventListener) element.addEventListener(type, handler, false);
    else if (element.attachEvent) element.attachEvent('on' + type, handler);
    else element['on' + type] = handler;
  },
  removeHandler: function (element: any, type: any, handler: any) {
    if (element.removeEventListener) element.removeEventListener(type, handler, false);
    else if (element.detachEvent) element.detachEvent('on' + type, handler);
    else element['on' + type] = handler;
  },
  /**
   * 监听触摸的方向
   * @param target            要绑定监听的目标元素
   * @param isPreventDefault  是否屏蔽掉触摸滑动的默认行为（例如页面的上下滚动，缩放等）
   * @param upCallback        向上滑动的监听回调（若不关心，可以不传，或传false）
   * @param rightCallback     向右滑动的监听回调（若不关心，可以不传，或传false）
   * @param downCallback      向下滑动的监听回调（若不关心，可以不传，或传false）
   * @param leftCallback      向左滑动的监听回调（若不关心，可以不传，或传false）
   */
  listenTouchDirection: function (target: any, isPreventDefault: any, upCallback: any, rightCallback: any, downCallback: any, leftCallback: any) {
    this.addHandler(target, 'touchstart', handleTouchEvent);
    this.addHandler(target, 'touchend', handleTouchEvent);
    this.addHandler(target, 'touchmove', handleTouchEvent);
    let startX: any;
    let startY: any;
    function handleTouchEvent(event: any) {
      switch (event.type) {
        case 'touchstart':
          startX = event.touches[0].pageX;
          startY = event.touches[0].pageY;
          break;
        case 'touchend':
          var spanX = event.changedTouches[0].pageX - startX;
          var spanY = event.changedTouches[0].pageY - startY;

          if (Math.abs(spanX) > Math.abs(spanY)) {
            //认定为水平方向滑动
            if (spanX > 30) {
              //向右
              if (rightCallback) rightCallback();
            } else if (spanX < -30) {
              //向左
              if (leftCallback) leftCallback();
            }
          } else {
            //认定为垂直方向滑动
            if (spanY > 30) {
              //向下
              if (downCallback) downCallback();
            } else if (spanY < -30) {
              //向上
              if (upCallback) upCallback();
            }
          }

          break;
        case 'touchmove':
          //阻止默认行为
          if (isPreventDefault) event.preventDefault();
          break;
        default:
          break;
      }
    }
  }
};

//antd 弹框默认事件
function closest(el: any, selector: any) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

export function onWrapTouchStart(e: any) {
  // fix touch to scroll background page on iOS
  if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
    return;
  }
  const pNode = closest(e.target, '.am-modal-content');
  if (!pNode) {
    e.preventDefault();
  }
}
//格式化价格
export function toDecimal2(x: any) {
  let f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  let h = Math.round(x * 100) / 100;
  let s = h.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;
}
//分转元
export function regFenToYuan(fen: any, decimal: 1 | 2 = 2, deleteZero = false) {
  let num = fen;
  num = fen * 0.01;
  num += '';
  let reg = num.indexOf('.') > -1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g;
  num = num.replace(reg, '$1');
  num = toDecimal2(num);

  if (typeof num === 'string') {
    let n = num.split('.')[1].slice(0, decimal);
    if (deleteZero && Number(n) === 0) {
      num = num.split('.')[0];
    } else if (decimal === 1) {
      num = num.slice(0, num.length - 1);
    }
  }

  return num;
}
//元转分
export function regYuanToFen(yuan: any, digit = 100) {
  let m = 0;
  let s1 = yuan.toString();
  let s2 = digit.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {}
  try {
    m += s2.split('.')[1].length;
  } catch (e) {}
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
}

export function getDecimal(num: number | string, count = 2) {
  if (typeof num === 'string') num = Number(num);

  const n = Math.pow(10, count);

  return Math.floor(num * n) / n;
}

//兼用安卓window.replace 跳转
export function locationReplace(url: string) {
  if (window.history.replaceState) {
    window.history.replaceState(null, document.title, url);
    window.history.go(0);
  } else {
    window.location.replace(url);
  }
}
//检查版本号
export function compareVersionEle(targetVerison: string) {
  let currVersion = getCookie('zwzt_version');
  //currVersion  当前版本
  //targetVerison  目标版本
  if (!targetVerison) return false;
  const curr = currVersion.split('.');
  const target = targetVerison.split('.');
  for (let i = 0; i < curr.length; i++) {
    if (parseInt(curr[i]) > parseInt(target[i])) {
      return true;
    }
    if (parseInt(curr[i]) < parseInt(target[i])) {
      return false;
    }
    //相等继续
    //parseInt(curr[i]) == parseInt(target[i])  continue
  }
  return true;
}
//序列化URL后的参数
export function qsStringifyUrl(url: string, data: any) {
  Object.keys(data).map(key => {
    if (data[key] === '') {
      delete data[key];
    }
    return key;
  });
  let dataUrl = qs.stringify(data);
  let href = `${url}?${dataUrl}`;
  return href;
}
export function paramsFilter(data: any) {
  let dataUrl = qs.stringify(data);
  return dataUrl;
}
//查看是否已经登录
export function checkLogin() {
  return new Promise((resolve, reject) => {
    if (getCookie('zwzt_code') === '') {
      reject();
    } else {
      resolve('');
    }
  });
}

export const srollFunction: any = {
  scrollTop: null,
  doc: null,
  reg: null,
  bodyClassName: '',
  afterOpen: (bodyEle: any, bodyCls: string) => {
    srollFunction.doc = document.documentElement.scrollTop ? document.documentElement : bodyEle;
    srollFunction.scrollTop = srollFunction.doc.scrollTop;

    if (bodyEle.classList) {
      bodyEle.classList.add(bodyCls);
    } else {
      bodyEle.className += ' ' + bodyCls;
    }

    bodyEle.style.top = -srollFunction.scrollTop + 'px';
    srollFunction.bodyClassName = bodyEle.className;
  },
  beforeClose: (bodyEle: any, bodyCls: string) => {
    if (bodyEle.classList) {
      bodyEle.classList.remove(bodyCls);
    } else {
      srollFunction.reg = new RegExp('\\b' + bodyCls + '\\b', 'gi');
      if (srollFunction.reg.test(srollFunction.bodyClassName)) {
        srollFunction.bodyClassName = srollFunction.bodyClassName.replace(srollFunction.reg, '');
        bodyEle.className = srollFunction.bodyClassName;
      }
    }

    bodyEle.style.top = '';
    srollFunction.doc.scrollTop = srollFunction.scrollTop;
  }
};

export function scrollMore(isBtn: boolean) {
  return new Promise((resolve, reject) => {
    let scrollTop = window.scrollY + document.documentElement.clientHeight;
    let pageHeight = document.body.scrollHeight;
    // 判断是否到底，是否可以加载下一页
    if (scrollTop >= pageHeight - 100 && isBtn) {
      resolve('');
    }
  });
}

export const compatibleVersionHerf = (url: string, type = 1) => {
  //type 1需要拼接window.localtion.origin   2不需要拼接
  //检验是否5.3.0及以上版本，5.3.0以下的版本用location.href跳转，以上的版本用路由跳转
  if (compareVersionEle('5.3.0')) {
    let urls = type === 1 ? `${window.location.origin}${url}` : url;
    let hrefUrl = encodeURIComponent(urls);
    jsBridge.routerToNativePage(hrefUrl);
  } else {
    window.location.href = url;
  }
};

//查看是否已经登录
export function checkInnerApp(): boolean {
  return getCookie('zwzt_version') === '' ? false : true;
}

export const articleTypeText = ['短纸条', '通知纸条', '音频纸条', '图文纸条'];
// 格式化层次标签
export function gradesFormatToText(grades: any, separator = '，') {
  const gradesText = [, '小学', '初中', '高中'];
  return grades && grades !== '-' ? grades.split(',').reduce((pre: any, aft: any) => `${pre}${pre ? separator : ''}${gradesText[aft]}`, '') : '-';
}
export function formatAudioTime(time: any) {
  let t: any = time / 60;
  let min = parseInt(t);
  let sec = time % 60;

  return `${min >= 10 ? min : `0${min}`}:${sec >= 10 ? sec : `0${sec}`}`;
}
/**
 * 监听HTML元素是否滚动到底部 : 兼容ES5
 * @param {object} ele HTML元素
 * @param {function} callback 滚动到底部后的回调函数
 */
export function listenScrollToBottom(ele: any, callback: any) {
  if (ele === null || ele === undefined) {
    // 节点不存在：抛出错误
    throw new Error('Undefined COM');
  }
  ele.addEventListener('scroll', throttle(ele, callback), false); // 监听 scroll 事件
}
// 节流函数 : 减少浏览器内存消耗
export function throttle(ele: any, callback: any) {
  let isRunning = false;
  return function () {
    if (isRunning) return;
    isRunning = true;
    // requestAnimationFrame:回调间隔 = 浏览器重绘频率
    window.requestAnimationFrame(function (timestamp) {
      let scrollTop = window.scrollY + document.documentElement.clientHeight;
      let pageHeight = document.body.scrollHeight;
      if (scrollTop >= pageHeight - 100) {
        // 检测是否滚动到元素底部
        callback();
      }
      isRunning = false;
    });
  };
}
//纸条投稿
export function NoteContributeAction(data: any) {
  if (_IsAS() === IOS_SIGN) {
    window &&
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.NoteContributeAction &&
      window.webkit.messageHandlers.NoteContributeAction.postMessage(data);
  } else if (_IsAS() === ANDROID_SIGN) {
    window && window.android && window.android.noteContributeAction(JSON.stringify(data));
  }
}
//自由投稿
export function FreeStyleContributeAction(data: any) {
  if (_IsAS() === IOS_SIGN) {
    window &&
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.FreeStyleContributeAction &&
      window.webkit.messageHandlers.FreeStyleContributeAction.postMessage(data);
  } else if (_IsAS() === ANDROID_SIGN) {
    window && window.android && window.android.freeStyleContributeAction(JSON.stringify(data));
  }
}
//纸条详情
export function contributeDetails(data: any) {
  if (_IsAS() === IOS_SIGN) {
    window &&
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.ContributeArticleAction &&
      window.webkit.messageHandlers.ContributeArticleAction.postMessage(data);
  } else if (_IsAS() === ANDROID_SIGN) {
    window && window.android && window.android.contributeArticleAction(JSON.stringify(data));
  }
}

export function checkIDCard(idcode: string) {
  // 加权因子
  var weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  // 校验码
  var check_code = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

  var code = idcode + '';
  var last = idcode[17]; //最后一位

  var seventeen = code.substring(0, 17);

  // ISO 7064:1983.MOD 11-2
  // 判断最后一位校验码是否正确
  var arr = seventeen.split('');
  var len = arr.length;
  var num = 0;
  for (var i = 0; i < len; i++) {
    num = num + Number(arr[i]) * weight_factor[i];
  }

  // 获取余数
  var resisue = num % 11;
  var last_no = check_code[resisue];

  // 格式的正则
  // 正则思路
  /*
  第一位不可能是0
  第二位到第六位可以是0-9
  第七位到第十位是年份，所以七八位为19或者20
  十一位和十二位是月份，这两位是01-12之间的数值
  十三位和十四位是日期，是从01-31之间的数值
  十五，十六，十七都是数字0-9
  十八位可能是数字0-9，也可能是X
  */
  var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;

  // 判断格式是否正确
  var format = idcard_patter.test(idcode);

  // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
  return last === last_no && format ? true : false;
}

// 其他模块
export function routerToNativePageByType() {
  // 点击引用模块
  let routers = document.querySelectorAll('.router-by_img');

  // 低版本浏览器 dom没有迭代器接口
  Array.prototype.forEach.call(routers, dom => {
    dom.addEventListener('click', (e: any) => {
      e.stopPropagation();
      let [link, params] = [dom.getAttribute('link'), dom.getAttribute('params')];
      let paramsString = '';
      let paramsMap = JSON.parse(params);
      if (paramsMap) {
        Object.keys(paramsMap).forEach(key => {
          paramsString += `${paramsString.indexOf('?') === -1 ? '?' : '&'}${key}=${paramsMap[key].val}`;
        });
      }
      jsBridge.routerToNativePage(`${link}${paramsString}`);
    });
  });
}

export function format(time:any,fmt:any) {
  if(!time) return ''
  
  let date = new Date(time);
  // let fmt = 'yyyy-MM-dd hh:mm:ss'

  if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  var o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
  };
  for (var k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
          var str = o[k] + '';
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
      }
  }
  return fmt;

}
